// types
import { Slide, Slide1 } from './types';

// images
import Avatar1 from '../../assets/images/avatars/human-icon.jpg';
// import Avatar2 from '../../assets/images/avatars/img-5.jpg';
import Amazon from '../../assets/images/brands/amazon.svg';
import Google from '../../assets/images/brands/google.svg';

import saas1 from '../../assets/images/sds-1.png';
import saas2 from '../../assets/images/sds-2.png';
import saas3 from '../../assets/images/sds-3.png';

const slides: Slide[] = [
    {
        statement:
            ' I have  been using this software for a few weeks now, and it is been a great help in saving time and reducing my burden. It simplifies my work and allows me to control every hoarding board. One intriguing feature is the deadline notification, which is quite helpful in extending time.',
        customer: {
            avatar: Avatar1,
            name: 'Minesh',
            designation: 'Apple adds - Nagercoil ',
        },
        logo: Amazon,
    },
    {
        statement:
            'My understanding of the software is facilitated by its user-friendly interface, and its private link feature for clients is an intriguing addition that truly comes in handy.After using it for a few weeks,  This was beneficial in terms of reducing workload and saving time.  ',
        customer: {
            avatar: Avatar1,
            name: 'Santhosh Raja',
            designation: 'MN Media - coimbatore',
        },
        logo: Google,
    },
];

const slides1: Slide1[] = [
    {
        image: saas1,
        slideTitle: 'Manage your saas business with ease',
        description:
            'Make your saas application stand out with high-quality landing page designed and developed by professional.',
    },
    {
        image: saas2,
        slideTitle: 'The best way to showcase your mobile app',
        description: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium.',
    },
    {
        image: saas3,
        slideTitle: 'Smart Solution that convert Lead to Customer',
        description: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium.',
    },
];

export { slides, slides1 };
